export const ERROR_MODE_CUSTOM = 'ERROR_MODE_CUSTOM'
export const ERROR_MODE_EXTERNAL = 'ERROR_MODE_EXTERNAL'
export const ERROR_MODE_SERVER = 'ERROR_MODE_SERVER'
